import { useParams } from 'react-router-dom';
import { Modal } from 'antd';
import { MindMapContext } from '../../Context/contex';
import useMindMapService from '../../hooks/useMindMapService';
import { emitEdgeDelete, emitNodeDelete } from '../../Socket/socket';

const EMPTY_MAP = { nodes: [], edges: [] };

/**
 * Returns a function that asks, then clears the whole map: every node and connection. It is saved in one request,
 * by replacing the map with an empty one through the import endpoint (a template saves its empty snapshot instead),
 * sent to collaborators, and undone in one step. An empty map has nothing to clear.
 */
export const useClearMap = () => {
    const { documentId } = useParams();
    const { nodes, edges, setNodes, setEdges, recordChange, setIsDocumentChanged } = MindMapContext();
    const mindMapService = useMindMapService();

    const clear = () => {
        recordChange({ nodes, edges }, EMPTY_MAP);
        setNodes([]);
        setEdges([]);
        mindMapService.saveImportDataToDb({ ...EMPTY_MAP, documentId }, EMPTY_MAP);
        edges.forEach((edge) => emitEdgeDelete({ selectedEdgeId: edge.id, documentId }));
        nodes.forEach((node) => emitNodeDelete({ selectedNodeId: node.id, documentId }));
        setIsDocumentChanged(true);
    };

    return () => {
        if (nodes.length === 0) return;
        Modal.confirm({
            title: 'Clear the mind map?',
            content: 'Every shape and connection is removed for everyone. You can undo it with Ctrl+Z.',
            okText: 'Clear',
            okButtonProps: { danger: true },
            cancelText: 'Cancel',
            onOk: clear,
        });
    };
};
